<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="importproc_name" [(ttModel)]="edit.importproc_name" ttRequired></tt-input>
        <tt-input ttLabel="filename" [(ttModel)]="edit.filename" ttRequired></tt-input>
        <tt-input ttLabel="proc_name" [(ttModel)]="edit.proc_name" ttRequired></tt-input>
        <tt-select ttLabel="encodingtype" [(ttModel)]="edit.encodingtype" [ttData]="selectListEncodingTypes" ttDataId="encodingtype" ttDataName="encodingtype_name"></tt-select>
        <tt-checkbox ttLabel="must_run_sequentially" [(ttModel)]="edit.must_run_sequentially"></tt-checkbox>
        <tt-checkbox ttLabel="stop_on_error" [(ttModel)]="edit.stop_on_error"></tt-checkbox>
        <tt-checkbox ttLabel="show_in_excelimport" [(ttModel)]="edit.show_in_excelimport"></tt-checkbox>
        <tt-textarea ttLabel="searchtext1" [(ttModel)]="edit.searchtext1"></tt-textarea>
        <tt-checkbox ttLabel="show_table_name_destination" [(ttModel)]="edit.show_table_name_destination"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
